<template>
    <div id="verify">
      <el-tabs class="main_tabs" v-model="activeName" type="card">
        <el-tab-pane name="Offered" label="实名认证" :lazy="true">
            <div class="verify">
                    <div class="verify-item">
                        <div class="verify-ope">
                            <div class="verify-top">
                                <span>1</span>
                                <div>
                                    <div>上传电子档头像照片</div>
                                    <div>请上传{{name}}本人头像照片</div>
                                </div>
                            </div>
                            <div>
                                <el-upload
                                    class="upload-demo"
                                    :action="fileurl"
                                    :on-success="headUpload"
                                    :before-upload="beforeUpload"
                                    :show-file-list="false"
                                    list-type="picture">
                                    <img :src="headImg" class="basic-avatar" v-if="headImg">
                                    <img v-else src="../../../static/images/avator.png">
                                </el-upload>
                            </div>
                        </div>
                        
                        <div class="verify-ope">
                            <div class="verify-top">
                                <span>2</span>
                                <div>
                                    <div>上传身份证人像页照片</div>
                                    <div>请上传{{name}}本人身份证人像页照片</div>
                                </div>
                            </div>
                            <div>
                                <el-upload
                                    class="upload-demo"
                                    :action="fileurl"
                                    :on-success="headUploads"
                                    :before-upload="beforeUpload"
                                    :show-file-list="false"
                                    list-type="picture">
                                    <img :src="idcardImg" class="basic-avatar" v-if="idcardImg">
                                    <img v-else src="../../../static/images/idCard.png">
                                </el-upload>
                            </div>
                        </div>
                    </div>
                     <div class="item-text">
                                <div>上传照片要求：<span>查看示例</span></div>
                                <div>1.请上传清晰彩色完整的电子档头像照片；</div>
                                <div>2.请上传您的二代居民身份证原件，并确保文字清晰，无反光，无遮挡。</div>
                    </div>
                    <el-form :model="userinfo" class="edit-dialog showdialog"  ref="userinfo">
                         <el-form-item label="身份证号:" prop="idcard" >
                            <el-input v-model.trim="userinfo.idCard" type="text" autocomplete="off" placeholder="上传身份证照片后自动显示" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名:" prop="name" >
                             <el-input v-model.trim="userinfo.name" type="text" autocomplete="off" placeholder="上传身份证照片后自动显示" :disabled="true"></el-input>
                         </el-form-item>
                    </el-form>
                    <div class="actionButton clearfix">
                        <el-button type="primary" size="medium" style="width:60%;margin:30px 20%;" @click="save">保存</el-button>         
                    </div>
                    
            </div>
        </el-tab-pane>
       
    </el-tabs>
    </div> 
</template>

<script>
  import CryptoJS from 'crypto-js';  
  import axios from 'axios';
  export default {
    name: "",
    data(){
      return {
        activeName: 'Offered',
        tabIndex: '0',
        fileurl: this.$global.fileurl,
        userinfo:{
            name:'',
            idCard:'',
            photoImg:"",
            idCardImg:""
        },
        headImg:"",
        idcardImg:"",
        name:""
      }
    },
    mounted(){
         let userinfo = window.sessionStorage.getItem('userinfo');
        userinfo = JSON.parse(userinfo);
       this.name=userinfo.name
      
    },
    methods:{
        beforeUpload(file) {
        let flag = false;
        if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
          this.$message({message: '只能上传JPG/PNG/GIF图片！', type: 'error'});
        } else if (file.size > this.$global.imageMaxSize) {
          this.$message({message: '上传图片不能超过' + this.$global.imageMaxSizeText, type: 'error'});
        } else {
          flag = true;
        }
        return flag;
      },
       /*切换头像 */
      async headUpload(response, file, fileList){
        let me = this;
        if(response&&response['success']){
            let str='http://120.77.227.46/file/pub/download?fileId='+response['content'][0];
           me.$set(me.userinfo,'photoImg',response['content'][0])
            me.headImg=str;
        }
      },
       async headUploads(response, file, fileList){
        let me = this;
         const fullscreenLoading = this.$loading({
        lock: true,
        text: "图片上传中请稍等....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
        if(response&&response['success']){
            let str='http://120.77.227.46/file/pub/download?fileId='+response['content'][0];
            let idimg=response['content'][0];
            var secretId = 'AKID6E9tMmTMi4OOYUMmnuVaYUJwjFVaxEED',
                secretKey = '363nNqBQZVFpvoTkqyReNwGZgfQzNaZK',
                appid = '1259048388',
                pexpired = 86400,
                userid = 0;
              var now = parseInt(Date.now() / 1000),
                rdm = parseInt(Math.random() * Math.pow(2, 32)),
                originalStr = 'a=' + appid + '&k=' + secretId + '&e=' + (now + pexpired) + '&t=' + now + '&r=' + rdm + userid + '&f=';
              var originalStrWordArray = CryptoJS.enc.Utf8.parse(originalStr); // 将源签名串解析成 wordArray 类型
              var signWordArray = CryptoJS.HmacSHA1(originalStr, secretKey);
              var concatWordArray = signWordArray.concat(originalStrWordArray); // 通过 wordArray concat 将两个数据进行拼接合并
              var authorization = CryptoJS.enc.Base64.stringify(concatWordArray); // 最终进行 Base64 编码，成功生成签名串
              let param={
                    appid:'1259048388',
                    url_list:str
              };
              axios({
					url:'https://recognition.image.myqcloud.com/ocr/idcard',
					method: 'post',
					data: param,
					headers:{
						 "Content-Type": "application/json",
                        // "Access-Control-Allow-Origin": "*",
                        'authorization': authorization
					}
					
				})
				.then(res=>{
                     setTimeout(() => {
                            fullscreenLoading.close();
                        },500);
                let data = res.data.result_list[0];
                if (res.data.result_list[0].code == '0'&&data.data.name&&data.data.id) { 
                        me.$set(me.userinfo,'idCard',res.data.result_list[0].data.id)   
                        me.$set(me.userinfo,'name',res.data.result_list[0].data.name)
                        me.$set(me.userinfo,'idCardImg',idimg)
                        me.idcardImg=str;      
                  } else if (res.data.result_list[0].code == '15') {
                    me.$message.error('操作太频繁，稍后再试')
                  
                  } else if (res.data.result_list[0].code == '-5110') {
                   me.$message.error('请上传正确身份证照片')
                  
                  } else if (res.data.result_list[0].code == '20') {
                   
                    me.$message.error('图片太大')
                  } else if (res.data.result_list[0].code == '-1404') {
                   
                    me.$message.error('图片无法识别')
                  } else if (res.data.result_list[0].code == '-5062') {
                   
                   me.$message.error('请重新拍摄后再上传')
                  } else if (res.data.result_list[0].code == '-5103') {
                  
                  me.$message.error('识别失败，请重新上传或换图')
                  } else if (res.data.result_list[0].code == '-5107') {
                   
                     me.$message.error('提供的图片不是身份证图片')
                  }else{
                      me.$message.error('识别失败，请重新拍照上传') 
                 
                  }
               })
        }else{
             setTimeout(() => {
                fullscreenLoading.close();
            },500);
        }
      },
      async save(){
           let me = this;
           let param=me.userinfo;
           param.photoImg=me.headImg;
           if(!param.photoImg){
               me.$message({
                    message: '请上传头像照片',
                    type: 'warning'
                });
                return;
           }
           if(!param.idCardImg){
               me.$message({
                    message: '请上传头像照片',
                    type: 'warning'
                });
                return;
           }
       let res = await me.$userService.auth(param);
            if (res && res["success"]){
               me.$router.push({ name: "hello" });
               me.userinfo={
                    name:'',
                    idCard:'',
                    photoImg:"",
                    idCardImg:""
               }
            }
      },
        async tencent(){
            let me=this;

        }
    }
  }

  
</script>

<style lang="scss">
   
    #verify{
        .verify{
            width: 670px;
            margin:0 auto;
            .verify-item{
                display: flex;justify-content: space-between;
            }
            .el-form-item__content{
                display: flex;   
            }
            .el-input__inner{
                border: none;
                border-bottom: 1px solid #e8e8e8;
                border-radius: 0;
            }
            .el-form-item{
                margin-bottom: 10px;
            }
             .el-form-item__label{
                    width: 90px;
                    color: #666;
                    font-size: 16px;
                }
                .el-input.is-disabled .el-input__inner{
                    background:#fff;
                }
            .item-text{
                margin:25px 0 35px 0;
                div{
                    font-size: #666;margin:6px 0;
                    font-size: 16px;
                    span{
                        color: #0979c5;
                    }
                }
            }
            .verify-ope{
                    display: flex;
                    flex-direction: column;align-items: center;
                    .verify-top{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 16px;
                        div{
                            margin:5px 0;
                        }
                        div:first-child{
                            color: #333;font-weight: 700;
                        }
                    }
                    div{
                        img{
                            width:240px;
                            height:160px;
                            // height:120px;
                        }
                    }
                    span{
                        display: inline-block;line-height: 30px;margin-right: 10px;
                        width:30px;height:30px;text-align: center;border:1px solid #ccc;border-radius: 50%;
                    }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/user/verify.vue